<template>
  <section class="app-main" :key="pageCacheVersion">
    <keep-alive :max="20">
      <router-view
        v-if="isMainLayoutRoute && $route.meta.keepAlive"
        :key="`${$route.name || $route.path}-${pageCacheVersion}`"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="isMainLayoutRoute && (!$route.meta || !$route.meta.keepAlive)"
      :key="$route.fullPath"
    ></router-view>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'AppMain',
  computed: {
    ...mapGetters([
      'pageCacheVersion'
    ]),
    isMainLayoutRoute() {
      return this.$route.matched.some(item => item.meta && item.meta.keepRootLayout)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue